"use client";
import { CosmosButton, CosmosIconChevronRight } from "@cosmos/web/react";
import { Kicker } from "../../kicker/kicker";
import { BlocksYearMap } from "../../../__generated__/contentful-types";
import { useViewportDimensions } from "../../../helpers/useViewportDimensions";
import { responsiveImageHelper } from "../../../helpers/responsiveImageHelper";
import { useImageLoading } from "../../../helpers/ImageLoadingContext";
import classnames from "classnames/bind";
import styles from "./year-map.module.css";
import { useKickerContext } from "../../../helpers/KickerContext";

const TABLET_BREAKPOINT = 650;
const ITEMS = 2;
const cx = classnames.bind(styles);

export const YearMap = ({ block }: { block: BlocksYearMap }) => {
  const { viewportWidth } = useViewportDimensions();
  const imageLoading = useImageLoading();

  const kickerKind = useKickerContext();

  return (
    <div className={cx("container")}>
      <div className={cx("inner")}>
        <div className={cx("main")}>
          {block.highlightIntrosCollection?.items[0] && (
            <div className={cx("text-wrapper", "text-wrapper--above")}>
              {(block.highlightIntrosCollection.items[0].kicker ||
                block.highlightIntrosCollection.items[0].title) && (
                <div className={cx("heading-group")}>
                  {block.highlightIntrosCollection.items[0].kicker && (
                    <Kicker
                      className={cx("kicker")}
                      kind={kickerKind}
                      text={block.highlightIntrosCollection.items[0].kicker}
                    />
                  )}
                  {block.highlightIntrosCollection.items[0].title && (
                    <h2 className={cx("title")}>
                      {block.highlightIntrosCollection.items[0].title}
                    </h2>
                  )}
                </div>
              )}
              <p className={cx("description")}>
                {block.highlightIntrosCollection.items[0].description}
              </p>
              {block.highlightIntrosCollection.items[0].linkUrl &&
              block.highlightIntrosCollection.items[0].linkText &&
              block.highlightIntrosCollection.items[0].buttonText &&
              viewportWidth < TABLET_BREAKPOINT ? (
                <div className={cx("button-wrapper")}>
                  <CosmosButton
                    href={block.highlightIntrosCollection.items[0].linkUrl}
                    size="medium"
                    kind="link"
                    icon-placement="after"
                    className={cx("button")}
                  >
                    <CosmosIconChevronRight
                      slot="icon"
                      className={cx("button-icon")}
                    />
                    {block.highlightIntrosCollection.items[0].linkText}
                  </CosmosButton>
                </div>
              ) : (
                <div className={cx("button-wrapper")}>
                  <CosmosButton
                    href={
                      block.highlightIntrosCollection.items[0].linkUrl ??
                      undefined
                    }
                    kind="primary"
                    size="large"
                    className={cx("button")}
                  >
                    {block.highlightIntrosCollection.items[0].buttonText}
                  </CosmosButton>
                </div>
              )}
            </div>
          )}
          {block.artwork?.url && (
            <div className={cx("image-wrapper")}>
              <div className={cx("image-inner-wrapper")}>
                <img
                  loading={imageLoading}
                  srcSet={responsiveImageHelper.createContentfulSrcSet(
                    block.artwork.url,
                  )}
                  sizes="min(100vw, 830px)"
                  className={cx("image")}
                  alt={block.artwork.description ?? ""}
                />
              </div>
            </div>
          )}
          {block.highlightIntrosCollection?.items[1] &&
            block.highlightIntrosCollection.items.length === ITEMS && (
              <div className={cx("text-wrapper", "text-wrapper--below")}>
                {(block.highlightIntrosCollection.items[1].kicker ||
                  block.highlightIntrosCollection.items[1].title) && (
                  <div className={cx("heading-group")}>
                    {block.highlightIntrosCollection.items[1].kicker && (
                      <Kicker
                        className={cx("kicker")}
                        kind="underlined"
                        text={block.highlightIntrosCollection.items[1].kicker}
                      />
                    )}
                    {block.highlightIntrosCollection.items[1].title && (
                      <h2 className={cx("title")}>
                        {block.highlightIntrosCollection.items[1].title}
                      </h2>
                    )}
                  </div>
                )}
                <p className={cx("description")}>
                  {block.highlightIntrosCollection.items[1].description}
                </p>
                {block.highlightIntrosCollection.items[1].linkUrl &&
                block.highlightIntrosCollection.items[1].linkText &&
                block.highlightIntrosCollection.items[1].buttonText &&
                viewportWidth < TABLET_BREAKPOINT ? (
                  <div className={cx("button-wrapper")}>
                    <CosmosButton
                      href={block.highlightIntrosCollection.items[1].linkUrl}
                      size="medium"
                      kind="link"
                      icon-placement="after"
                      className={cx("button")}
                    >
                      <CosmosIconChevronRight
                        slot="icon"
                        className={cx("button-icon")}
                      />
                      {block.highlightIntrosCollection.items[1].linkText}
                    </CosmosButton>
                  </div>
                ) : (
                  <div className={cx("button-wrapper")}>
                    <CosmosButton
                      href={
                        block.highlightIntrosCollection.items[1].linkUrl ??
                        undefined
                      }
                      kind="primary"
                      size="large"
                      className={cx("button")}
                    >
                      {block.highlightIntrosCollection.items[1].buttonText}
                    </CosmosButton>
                  </div>
                )}
              </div>
            )}
        </div>
      </div>
    </div>
  );
};
